import spiderman from '@/spiderman/index';

async function getSchedule(member) {
  return (
    await spiderman.axios.get(spiderman.api.schedules, {
      headers: {
        jwt: member.jwt,
      },
      params: {
        clinic: member.info.clinic,
      },
    })
  ).data;
}

async function make(member, memberInfo, shiftInfo) {
  return (
    await spiderman.axios.post(spiderman.api.appointments,
      {
        clinic: member.info.clinic,

        name: memberInfo.name,
        id: memberInfo.id,
        birthdate: memberInfo.birthdate,
        mobile: memberInfo.mobile,

        shiftId: shiftInfo.shiftId,
        date: shiftInfo.date,
        note: shiftInfo.note,
      },
      {
        headers: {
          jwt: member.jwt,
        },
      })
  ).data;
}

async function query(member, queryForm) {
  return (
    await spiderman.axios.get(spiderman.api.appointments, {
      headers: {
        jwt: member.jwt,
      },
      params: {
        id: queryForm.id,
        birthdate: queryForm.birthdate,
      },
    })
  ).data;
}

async function cancel(member, appointmentInfo) {
  return (
    await spiderman.axios.delete(spiderman.api.appointments, {
      headers: {
        jwt: member.jwt,
      },
      params: {
        id: appointmentInfo.id,
        clinic: appointmentInfo.clinic,
        appointmentId: appointmentInfo.appointmentId,
      },
    })
  ).data;
}

export default {
  getSchedule,
  make,
  query,
  cancel,
};
